import React, { useState, useRef, useEffect } from "react";
import { MoreVertical } from "lucide-react";

import DeliverySection from "./DeliverySection";
import PaymentSection from "./PaymentSection";
import BillingSection from "./BillingSection";
import TipSection from "./TipSection";
import PayButton from "./PayButton";
import { useDispatch } from "react-redux";
import { logout } from "store/features/userSlice";

const CheckoutForm = ({ user, total, operator, isLoading }) => {
  const [tip, setTip] = useState(0);
  const [openMenu, setOpenMenu] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("online"); // 👈 move here
  const menuRef = useRef();
  const dispatch = useDispatch();

  // close menu when clicking outside
  useEffect(() => {
    const handleClick = (e) => {
      if (!menuRef.current?.contains(e.target)) {
        setOpenMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="space-y-8">
      {/* USER HEADER */}
      <div
        ref={menuRef}
        className="flex justify-between items-center border-b pb-4 relative"
      >
        <div className="flex items-center gap-2">Welcome:</div>

        <button
          onClick={() => setOpenMenu(!openMenu)}
          className="p-2 hover:bg-gray-100 rounded-full transition flex items-center gap-2"
        >
          <p className="font-semibold">{user?.username}</p>

          <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100  text-navy">
            <MoreVertical size={16} />
          </span>
        </button>

        {/* DROPDOWN */}
        {openMenu && (
          <div className="absolute right-0 top-10 bg-white border border-gray-200 shadow-lg rounded-lg w-52 overflow-hidden z-50">
            <button
              className="w-full text-left px-4 py-3 hover:bg-gray-50 text-sm"
              onClick={() => {
                dispatch(logout());
              }}
            >
              Switch account
            </button>
            {/* 
            <button
              className="w-full text-left px-4 py-3 hover:bg-gray-50 text-sm"
              onClick={() => {
                console.log("Checkout as guest");
              }}
            >
              Check out as guest
            </button> */}
          </div>
        )}
      </div>
      <DeliverySection operator={operator} isLoading={isLoading} />
      <PaymentSection
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
      />
      {/* <BillingSection user={user} /> */}
      {/* <TipSection total={total} setTip={setTip} /> */}
      <PayButton
        total={total}
        tip={0}
        paymentMethod={paymentMethod}
        operator={operator}
      />{" "}
    </div>
  );
};

export default CheckoutForm;
